import { create } from 'zustand'

const useTeamStore = create((set) => ({
  teams: [],
  
  // Simple action to update the list
  setTeams: (list) => set({ teams: list }),
  
  // Optional: clear the list
  clearTeams: () => set({ teams: [] }),
}))

export default useTeamStore;